import script from "./DocumentModalView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentModalView.vue?vue&type=script&setup=true&lang=js"

import "./DocumentModalView.vue?vue&type=style&index=0&id=37062c90&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37062c90"]])

export default __exports__